class CartManager {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        this.elementsDisplay = []
        this.elementsAction = []
    }
    run() {
        document.querySelectorAll('[data-cart]').forEach((el) => {
            const mCartDisplay = new CartDisplay(el, this)
            this.elementsDisplay.push(mCartDisplay)
        })
        document.querySelectorAll('[data-cart-add]').forEach((el) => {
            const mCartAction = new CartAction(el, this)
            mCartAction.run()
            this.elementsAction.push(mCartAction)
        })
    }
    updateQuantity(quantity) {
        this.elementsDisplay.forEach(el => {
            el.update(quantity)
        })
    }
}

class CartDisplay {
    constructor(el, parent) {
        this.el = el
        this.parent = parent
    }
    update(quantity) {
        this.el.addEventListener('animationend', () => {
            this.el.classList.remove('navbar-2__ico--is-animated')
            this.el.classList.remove('navbar__ico--is-animated')
        })
        this.el.classList.add('navbar-2__ico--is-animated')
        this.el.classList.add('navbar__ico--is-animated')
        this.el.querySelectorAll('span').forEach(el => {
            if (quantity > 0) {
                el.style.display = ''
            }
            el.innerHTML = quantity
        })
    }
}

class CartAction {
    constructor(el, parent) {
        this.el = el
        this.parent = parent
    }
    run() {
        this.el.addEventListener('submit', (ev) => {
            ev.preventDefault()
            this.activeLoading()
            this.submitHandler().then(() => {
                this.desactiveLoading()
                const event = new Event('show-extra')
                this.el.dispatchEvent(event)
            })
        })
        this.el.querySelectorAll('[data-cart-add-quantity]').forEach(el => {
            el.addEventListener('change', (ev) => {
                ev.preventDefault()
                this.submitHandler(true)
            })
        })
    }
    activeLoading() {
        this.el.querySelectorAll('[data-cart-add-action]').forEach(el => {
            el.classList.add(el.dataset.cartAddAction)
        })
    }
    desactiveLoading() {
        this.el.querySelectorAll('[data-cart-add-action]').forEach(el => {
            el.classList.remove(el.dataset.cartAddAction)
        })
    }
    submitHandler(absoluteQuantity = false) {
        return new Promise((resolve, reject) => {
            const formData = new FormData(this.el)
            formData.set('quantity-c', absoluteQuantity ? 'm' : 'f')
            if (false === absoluteQuantity) {
                formData.set('quantity', 1)
            }

            const object = {}
            formData.forEach((value, key) => object[key] = value)
            var json = JSON.stringify(object)
            console.log(json)

            fetch(this.el.getAttribute('action'), {
                body: formData,
                method: "post",
                headers: {
                    'Accept': 'application/json'
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (false === data.ok) {
                        resolve()
                        return
                    }

                    this.updateQuantity(data.quantity.newItem)
                    this.parent.updateQuantity(data.quantity.cart)

                    if (absoluteQuantity) {
                        resolve()
                        return
                    }
                    resolve()
                })
        })
    }
    updateQuantity(quantity) {
        this.el.querySelectorAll('[data-cart-add-quantity]').forEach(el => {
            el.value = quantity
        })
    }
}

export default CartManager